import React from 'react';
import Icon from '../../../components/AppIcon';

const EBookInfo = ({ ebook }) => {
  return (
    <div className="space-y-6">
      {/* Title & Subtitle */}
      <div className="space-y-3">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground">
          {ebook?.title}
        </h1>
        <p className="text-lg md:text-xl text-muted-foreground">{ebook?.subtitle}</p>

        <div className="flex flex-wrap items-center gap-4 text-sm text-muted-foreground">
          <div className="flex items-center gap-2">
            <Icon name="User" size={16} />
            <span>By {ebook?.author}</span>
          </div>
          {ebook?.publishDate && (
            <div className="flex items-center gap-2">
              <Icon name="Calendar" size={16} />
              <span>Published {ebook?.publishDate}</span>
            </div>
          )}
          {ebook?.category && (
            <div className="flex items-center gap-2">
              <Icon name="Tag" size={16} />
              <span>{ebook?.category}</span>
            </div>
          )}
        </div>
      </div>

      {/* Overview */}
      <div className="bg-card rounded-lg shadow-sm border border-border">
        <div className="p-4 md:p-6 border-b border-border">
          <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">
            Overview
          </h2>
        </div>
        <div className="p-4 md:p-6">
          <p className="text-foreground leading-relaxed whitespace-pre-line">{ebook?.description}</p>
        </div>
      </div>

      {/* What You'll Learn */}
      {ebook?.learningPoints?.length > 0 && (
        <div className="bg-card rounded-lg shadow-sm border border-border">
          <div className="p-4 md:p-6 border-b border-border">
            <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">
              What You'll Learn
            </h2>
          </div>
          <div className="p-4 md:p-6">
            <ul className="space-y-3">
              {ebook?.learningPoints?.map((point, index) => (
                <li key={index} className="flex items-start gap-3">
                  <Icon name="CheckCircle2" size={20} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
                  <span className="text-foreground">{point}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default EBookInfo;